import React, { useEffect, useRef, useState } from 'react';

// GIF-like auto-cycling image viewer. Cycles through `images` while `playing`.
// When not playing, shows the first frame.
export default function ImageLoop({ images = [], playing = false, interval = 900, className = '', alt = '', testId }) {
    const [idx, setIdx] = useState(0);
    const timer = useRef(null);
    const frames = images.filter(Boolean);

    useEffect(() => {
        if (!playing || frames.length <= 1) {
            setIdx(0);
            if (timer.current) clearInterval(timer.current);
            return;
        }
        timer.current = setInterval(() => setIdx((i) => (i + 1) % frames.length), interval);
        return () => timer.current && clearInterval(timer.current);
    }, [playing, frames.length, interval]);

    if (frames.length === 0) {
        return <div className={`flex items-center justify-center text-[var(--ink-muted)] text-xs ${className}`}>no image</div>;
    }

    return (
        <div className={`relative ${className}`} data-testid={testId}>
            {frames.map((src, i) => (
                <img
                    key={src || i}
                    src={src}
                    alt={alt}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-opacity duration-300"
                    style={{ opacity: i === idx ? 1 : 0 }}
                />
            ))}
            {/* keep a static base frame for layout height */}
            <img src={frames[0]} alt="" aria-hidden className="w-full h-full object-cover invisible" />
            {playing && frames.length > 1 && (
                <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
                    {frames.map((_, i) => (
                        <span key={i} className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: i === idx ? 'var(--brand-burgundy)' : 'rgba(255,255,255,0.7)' }} />
                    ))}
                </div>
            )}
        </div>
    );
}
